import React from 'react';

export const BannerDataSource = {
  wrapper: { className: 'banner1 jvovj88qaxm-editor_css' },
  BannerAnim: {
    children: [
      {
        name: 'elem0',
        BannerElement: { className: 'banner-user-elem' },
        textWrapper: {
          className: 'banner1-text-wrapper jvovb2rsub-editor_css',
        },
        bg: { className: 'bg bg0' },
        title: {
          className: 'banner1-title jvova3vfi6n-editor_css',
          children: (
            <>
              <p>开放赋能车商生态，共建产业数字文明</p>
            </>
          ),
        },
        content: {
          className: 'banner1-content',
          children: (
            <>
              <p>
                <br />
              </p>
            </>
          ),
        },
        button: {
          link: '/documents/docking_process',
          className: 'banner1-button jvovix9uns-editor_css',
          children: (
              <span>开始接入</span>
          ),
        },
      },

    ],
  },
};
export const SolutionDataSource = {
  wrapper: { className: 'home-page-wrapper content0-wrapper' },
  page: { className: 'home-page content0' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <>
            <p>开放版图</p>
          </>
        ),
      },
    ],
  },
  block: {
    className: 'block-wrapper',
    children: [
      {
        name: 'block0',
        className: 'block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'icon',
            children:
              'https://assets-devops.oss-cn-hangzhou.aliyuncs.com/f2e/58eb15093baa4e10cd35de7443a86e7c.png',
          },
          title: { className: 'content0-title', children: '数据智能开放' },
          content: { className: 'content0-content', children: '行业数据赋能，打通人车流通' },
          link: 'https://di-open.souche.com'
        },
      },
      {
        name: 'block2',
        className: 'block',
        md: 8,
        xs: 24,
        gray: true,
        children: {
          icon: {
            className: 'icon',
            children:
              'https://assets-devops.oss-cn-hangzhou.aliyuncs.com/f2e/c7ace4a88fb382d45f4cda32c657a853.png',
          },
          title: { className: 'content0-title', children: '服务开放（筹备中）' },
          content: { className: 'content0-content', children: '降本、增效、优化、共享' },
        },
      },
      {
        name: 'block3',
        className: 'block',
        md: 8,
        xs: 24,
        gray: true,
        children: {
          icon: {
            className: 'icon',
            children:
              'https://assets-devops.oss-cn-hangzhou.aliyuncs.com/f2e/c6f777e7c39a303129789b201e87cfd5.png',
          },
          title: { className: 'content0-title', children: '更多' },
          content: { className: 'content0-content', children: '敬请期待' },
        },
      },



    ],
  },
};
export const ScaleDataSource = {
  wrapper: { className: 'home-page-wrapper content01-wrapper' },
  page: { className: 'home-page content01' },
  OverPack: { playScale: 0.3, className: '' },
  block: {
    className: 'block-wrapper',
    children: [
      {
        name: 'block0',
        className: 'block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'icon',
            children:
              'https://assets-devops.oss-cn-hangzhou.aliyuncs.com/f2e/c6f777e7c39a303129789b201e87cfd5.png',
          },
          title: { className: 'content01-title', children: '90% 车商覆盖' },
          content: { className: 'content01-content', children: '大搜车已经数字化的全国90%中大型二手车商' },
        },
      },
      {
        name: 'block1',
        className: 'block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'icon',
            children:
              'https://assets-devops.oss-cn-hangzhou.aliyuncs.com/f2e/c7ace4a88fb382d45f4cda32c657a853.png',
          },
          title: { className: 'content01-title', children: '产业链服务能力'},
          content: { className: 'content01-content', children: '数万生态伙伴，诸多战略布局，具备较强产业链服务能力' },
        },
      },
      {
        name: 'block2',
        className: 'block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'icon',
            children:
              'https://assets-devops.oss-cn-hangzhou.aliyuncs.com/f2e/58eb15093baa4e10cd35de7443a86e7c.png',
          },
          title: { className: 'content01-title', children: '家选车商联盟' },
          content: { className: 'content01-content', children: '大搜车宣布：未来每年会投入10亿重金，支持“家选”车商联盟品牌发展' },
        },
      }
    ]
  }
}
export const PartnerDataSource = {
  wrapper: { className: 'home-page-wrapper content02-wrapper' },
  page: { className: 'home-page content02' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <>
            <p>成为我们的合作伙伴</p>
          </>
        ),
      },
    ],
  },
  block: {
    className: 'block-wrapper',
    children: [
      {
        name: 'block0',
        className: 'block',
        md: 6,
        xs: 24,
        children: {
          title: { className: 'content02-title', children: '注册认证' },
          content: { className: 'content02-content', children: '联系大搜车业务方，申请注册成为大搜车开放平台开发者，注册成功后分配账号' },
        },
      },
      {
        name: 'block1',
        className: 'block',
        md: 6,
        xs: 24,
        children: {
          title: { className: 'content02-title', children: '创建应用'},
          content: { className: 'content02-content', children: '大搜车业务方按需创建应用，分配对应配置' },
        },
      },
      {
        name: 'block2',
        className: 'block',
        md: 6,
        xs: 24,
        children: {
          title: { className: 'content02-title', children: '开发测试' },
          content: { className: 'content02-content', children: '调用 API 完成业务开发联调并测试' },
        },
      },
      {
        name: 'block3',
        className: 'block',
        md: 6,
        xs: 24,
        children: {
          title: { className: 'content02-title', children: '发布上线' },
          content: { className: 'content02-content', children: '审核后发布上线' },
        },
      }
    ]
  },
  signIn: {
    className: 'content02-signInBlock',
    style: { display: 'flex', alignItems: 'center', justifyContent: 'center'},
    children: {
      btn: { className: 'content02-btn', style: { display: 'flex', alignItems: 'center', justifyContent: 'center'}}
    }
  }
}
export const FooterDataSource = {
  wrapper: { className: 'home-page-wrapper footer1-wrapper' },
  OverPack: { className: 'footer1', playScale: 0.2 },
  block: {
    className: 'home-page',
    children: [
      {
        name: 'block1',
        xs: 24,
        md: 6,
        className: 'block jvox4vl2x56-editor_css',
        title: {
          children: (
            <>
              <p>新手入门</p>
            </>
          ),
        },
        content: {
          children: (
            <>
              <p>
                {' '}
                <a href="#/documents/docking_process">新手指南</a>{' '}
              </p>{' '}
              <p>
                {' '}
                <a  href="/#/support/FAQ">热门FAQ</a>{' '}
              </p>{' '}
              {/*<p>*/}
                {/*{' '}*/}
                {/*<a href>合作攻略</a>{' '}*/}
              {/*</p>{' '}*/}
              {/*<p>*/}
                {/*{' '}*/}
                {/*<a href>平台规则</a>{' '}*/}
              {/*</p>*/}
            </>
          ),
        },
      },
      {
        name: 'block2',
        xs: 24,
        md: 6,
        className: 'block jvox59jj2z-editor_css',
        title: {
          children: (
            <>
              <p>服务支持</p>
            </>
          ),
        },
        content: {
          children: (
            <>
              <p>
                {' '}
                <a href="#/documents/docking_process">开发文档</a>{' '}
              </p>{' '}
              <p>
                {' '}
                <a href="#/documents/docs">业务文档</a>{' '}
              </p>{' '}
              {/*<p>*/}
                {/*{' '}*/}
                {/*<a href>模板下载</a>{' '}*/}
              {/*</p>*/}
            </>
          ),
        },
      },
      {
        name: 'block3',
        xs: 24,
        md: 6,
        className: 'block jvox9n79gyd-editor_css',
        title: {
          children: (
            <>
              <p>客服帮助</p>
            </>
          ),
        },
        content: {
          children: (
            <>
             <p>
                {' '}
                <a href="/#/support/FAQ">技术支持中心</a>{' '}
              </p>{' '}
              {/*<p>*/}
                {/*{' '}*/}
                {/*<a href>在线问答</a>{' '}*/}
              {/*</p>*/}
            </>
          ),
        },
      },
      {
        name: 'block~jvox51l15ip',
        xs: 24,
        md: 6,
        className: 'block jvoxa8ee67p-editor_css',
        title: {
          children: (
            <>
              <p>搜车旗下</p>
            </>
          ),
        },
        content: {
          children: (
            <>
              <p>
                {' '}
                <a href="https://www.dasouche.com">大搜车官网</a>{' '}
              </p>
              <p>
                {' '}
                <a href="https://www.souche.com">大搜车家选</a>{' '}
              </p>
              <p>
                {' '}
                <a href="https://www.tangeche.com/">弹个车</a>{' '}
              </p>
              <p>
                {' '}
                <a href="https://www.dasouche.com/zh/html/products/">更多</a>{' '}
              </p>
            </>
          ),
        },
      },
      // {
      //   name: 'block~jvoxaju8yxq',
      //   xs: 24,
      //   md: 6,
      //   className: 'block jvoxa8ee67p-editor_css',
      //   title: {
      //     children: (
      //       <>
      //         <p>关注我们</p>
      //       </>
      //     ),
      //   },
      //   content: {
      //     children: (
      //       <>
      //         <p>
      //           {' '}
      //           <a href>关注平台移动门户</a>{' '}
      //         </p>
      //       </>
      //     ),
      //   },
      // },
    ],
  },
  copyrightWrapper: { className: 'copyright-wrapper' },
  copyrightPage: { className: 'home-page' },
  copyright: {
    className: 'copyright',
    children: (
      <>
        <span>Copyright ©2019 杭州大搜车 | ICP证京ICP备13012136号-2</span>
      </>
    ),
  },
};
export const OutputPowerDataSource = {
  wrapper: { className: 'home-page-wrapper content3-wrapper' },
  page: { className: 'home-page content3' },
  OverPack: { playScale: 0.3 },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <>
            <p>- 大搜车开放平台为你提供 -</p>
          </>
        ),
        className: 'title-h1',
      },
      {
        name: 'content',
        className: 'title-content',
        children: (
          <>
            <p>提供完善的开发机制，支持各种合作场景</p>
          </>
        ),
      },
    ],
  },
  block: {
    className: 'content3-block-wrapper',
    children: [
      {
        name: 'block0',
        className: 'content3-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'content3-icon',
            children:
              'https://assets-devops.oss-cn-hangzhou.aliyuncs.com/f2e/75250d4cfa2e500f4eed55209eeedee7.png',
          },
          textWrapper: { className: 'content3-text' },
          title: {
            className: 'content3-title',
            children: (
              <>
                <p>业务自助完成开放和接入</p>
              </>
            ),
          },
          content: {
            className: 'content3-content',
            children: (
              <>
                <p>提供完善的工具，自助完成业务开放和接入等</p>
              </>
            ),
          },
        },
      },
      {
        name: 'block1',
        className: 'content3-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'content3-icon',
            children:
              'https://assets-devops.oss-cn-hangzhou.aliyuncs.com/f2e/16b50c41ec8bb0be73f6b1d61390a223.png',
          },
          textWrapper: { className: 'content3-text' },
          title: {
            className: 'content3-title',
            children: (
              <>
                <p>数据安全保障</p>
              </>
            ),
          },
          content: {
            className: 'content3-content',
            children: (
              <>
                <p>精准的数据访问权限控制和预警，数据传输过程全程加密</p>
              </>
            ),
          },
        },
      },
      {
        name: 'block4',
        className: 'content3-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'content3-icon',
            children:
              'https://assets-devops.oss-cn-hangzhou.aliyuncs.com/f2e/734e23bd0e3bb36a5d612128ca459c9c.png',
          },
          textWrapper: { className: 'content3-text' },
          title: {
            className: 'content3-title',
            children: (
              <>
                <p>计费和结算</p>
              </>
            ),
          },
          content: {
            className: 'content3-content',
            children: (
              <>
                <p>支持多种接口和服务收费方式，实时结算和订阅结算等</p>
              </>
            ),
          },
        },
      },
      {
        name: 'block2',
        className: 'content3-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'content3-icon',
            children:
              'https://assets-devops.oss-cn-hangzhou.aliyuncs.com/f2e/f1953e6bfff05fd829f3bd46c15516e2.png',
          },
          textWrapper: { className: 'content3-text' },
          title: {
            className: 'content3-title',
            children: (
              <>
                <p>多样性对接机制</p>
              </>
            ),
          },
          content: {
            className: 'content3-content',
            children: (
              <>
                <p>接口合作，文件交换，消息队列，异步回调等</p>
              </>
            ),
          },
        },
      },
      {
        name: 'block3',
        className: 'content3-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'content3-icon',
            children:
              'https://assets-devops.oss-cn-hangzhou.aliyuncs.com/f2e/4ad5c2c74ba5258b351b637534d8b74b.png',
          },
          textWrapper: { className: 'content3-text' },
          title: {
            className: 'content3-title',
            children: (
              <>
                <p>可用性保障</p>
              </>
            ),
          },
          content: {
            className: 'content3-content',
            children: (
              <>
                <p>完善的报警和可用性保障机制，确保服务高可用</p>
              </>
            ),
          },
        },
      },

      {
        name: 'block5',
        className: 'content3-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'content3-icon',
            children:
              'https://assets-devops.oss-cn-hangzhou.aliyuncs.com/f2e/32ff521a6cc75e813158cdd209eec439.png',
          },
          textWrapper: { className: 'content3-text' },
          title: {
            className: 'content3-title',
            children: (
              <>
                <p>工单和帮助</p>
              </>
            ),
          },
          content: {
            className: 'content3-content',
            children: (
              <>
                <p>可以快速反馈和解决接入问题</p>
              </>
            ),
          },
        },
      },
    ],
  },
};




// export const Nav10DataSource = {
//   wrapper: { className: 'header1 home-page-wrapper' },
//   page: { className: 'home-page' },
//   logo: {
//     className: 'header1-logo',
//     // children: 'https://os.alipayobjects.com/rmsportal/mlcYmsRilwraoAe.svg',
//     children: (
//       <a><img width="100%" src={"https://assets-devops.oss-cn-hangzhou.aliyuncs.com/test/8e267003ff74e8f835df662316044dd6.png"} alt="img" />
//         <div class="title-area">
//           <div class="title">大搜车·开放平台</div>
//           <div className="subtitle">open.souche.com</div>
//         </div>
//       </a>
//     )
//   },
//   Menu: {
//     className: 'header1-menu',
//     children: [
//       {
//         name: 'item0',
//         a: {
//           children: (
//             <>
//               <p>开放门户版图</p>
//             </>
//           ),
//           href: '',
//           className: 'jvowjd8q0wa-editor_css',
//         },
//         sub: [{
//           children: '金融开放门户'
//         },
//           {
//             children: '新零售开放门户'
//           },{
//             children: '无线开放门户'
//           }]
//       },
//       {
//         name: 'item1',
//         a: {
//           children: (
//             <>
//               <p>开始接入</p>
//             </>
//           ),
//           blank: true,
//           href: 'opendocs.proxy.dasouche.com/start',
//           className: 'jvowjostl5l-editor_css',
//         },
//       },
//       {
//         name: 'item1',
//         a: {
//           children: (
//             <>
//               <p>文档中心</p>
//             </>
//           ),
//           blank: true,
//           href: 'https://opendocs.souche.com/docs',
//           className: 'jvowjostl5l-editor_css',
//         },
//       },
//
//       {
//         name: 'item3',
//         a: {
//           children: (
//             <>
//               <p>支持中心</p>
//             </>
//           ),
//           href: '',
//           className: 'jvowkc0a5qm-editor_css',
//         },
//         sub:[
//           {
//             children: '知识库'
//           },
//           {
//             children: '提工单'
//           }
//         ]
//       },
//       {
//         name: 'item2',
//         a: {
//           children: (
//             <>
//               <p>搜车官网</p>
//             </>
//           ),
//           blank: true,
//           href: 'https://www.dasouche.com',
//           className: 'jvowk6jw2t-editor_css',
//         },
//       },
//     ],
//   },
//   mobileMenu: { className: 'header1-mobile-menu' },
//   // help: { className: 'help', children: '帮助' },
//   user: {
//     className: 'header1-logo-right',
//     children: (
//       <a>
//         <span>登录控制台</span>
//       </a>
//     )
//   },
// };
// export const Banner20DataSource = {
//   wrapper: { className: 'banner2 jvovj88qaxm-editor_css' },
//   BannerAnim: {
//     children: [
//       {
//         name: 'elem0',
//         BannerElement: { className: 'banner-user-elem' },
//         textWrapper: {
//           className: 'banner2-text-wrapper jvovb2rsub-editor_css',
//         },
//         bg: { className: 'bg bg0' },
//         title: {
//           className: 'banner2-title jvova3vfi6n-editor_css',
//           children: (
//             <>
//               <p>开放赋能车商生态，共建产业数字文明</p>
//             </>
//           ),
//         },
//         content: {
//           className: 'banner2-content',
//           children: (
//             <>
//               <p>
//                 <br />
//               </p>
//             </>
//           ),
//         },
//         button: {
//           link: '/documents',
//           className: 'banner2-button jvovix9uns-editor_css',
//           children: (
//             <span>开始接入</span>
//           ),
//         },
//       },
//
//     ],
//   },
// };
// export const Feature40DataSource = {
//   wrapper: { className: 'home-page-wrapper content6-wrapper' },
//   OverPack: { className: 'home-page content6' },
//   textWrapper: { className: 'content6-text', xs: 24, md: 10 },
//   titleWrapper: {
//     className: 'title-wrapper',
//     children: [
//       {
//         name: 'title',
//         children: (
//           <>
//             <p>案例：资金方通用解决方案</p>
//           </>
//         ),
//         className: 'title-h1',
//       },
//       {
//         name: 'content',
//         className: 'title-content',
//         children: (
//           <>
//             <p>标准化资金接入解决方案</p>
//           </>
//         ),
//       },
//     ],
//   },
//   img: {
//     children: 'https://assets-devops.oss-cn-hangzhou.aliyuncs.com/test/e341e8194ba6b3a23a95fc7b4c246865.jpg',
//     className: 'content6-img jvyws7lm05e-editor_css',
//     xs: 24,
//     md: 14,
//   },
//   block: {
//     children: [
//       {
//         name: 'block0',
//         img: {
//           children:
//             'https://zos.alipayobjects.com/rmsportal/NKBELAOuuKbofDD.png',
//           className: 'content6-icon',
//         },
//         title: { className: 'content6-title', children: '技术' },
//         content: {
//           className: 'content6-content',
//           children: (
//             <>
//               <p>提供安全方便的文件交换方案，异步消息方案</p>
//             </>
//           ),
//         },
//       },
//       {
//         name: 'block1',
//         img: {
//           className: 'content6-icon',
//           children:
//             'https://zos.alipayobjects.com/rmsportal/xMSBjgxBhKfyMWX.png',
//         },
//         title: {
//           className: 'content6-title',
//           children: (
//             <>
//               <p>工具</p>
//             </>
//           ),
//         },
//         content: {
//           className: 'content6-content',
//           children: (
//             <>
//               <p>内部工作台，商户工作台，方便开发、接入、排查</p>
//             </>
//           ),
//         },
//       },
//       {
//         name: 'block2',
//         img: {
//           className: 'content6-icon',
//           children:
//             'https://zos.alipayobjects.com/rmsportal/MNdlBNhmDBLuzqp.png',
//         },
//         title: {
//           className: 'content6-title',
//           children: (
//             <>
//               <p>服务</p>
//             </>
//           ),
//         },
//         content: {
//           className: 'content6-content',
//           children: (
//             <>
//               <p>全程配合完成新的资金方接入</p>
//             </>
//           ),
//         },
//       },
//     ],
//   },
// };
// export const SolutionDataSource = {
//   wrapper: { className: 'home-page-wrapper content5-wrapper' },
//   page: { className: 'home-page content5' },
//   OverPack: { playScale: 0.3, className: '' },
//   titleWrapper: {
//     className: 'title-wrapper',
//     children: [
//       {
//         name: 'title',
//         children: (
//           <>
//             <p>解决方案</p>
//           </>
//         ),
//         className: 'title-h1',
//       },
//     ],
//   },
//   block: {
//     className: 'content5-img-wrapper',
//     gutter: 16,
//     children: [
//       {
//         name: 'block0',
//         className: 'block',
//         md: 8,
//         xs: 24,
//         children: {
//           wrapper: { className: 'content5-block-content' },
//           img: {
//             children:
//               'https://t.alipayobjects.com/images/rmsweb/T11aVgXc4eXXXXXXXX.svg',
//           },
//           title: { children: '淘宝解决方案' },
//           content: { className: 'content5-block-content-innerText', children: '此处添加相应解决方案' },
//           linkIn: { className: 'content5-block-content-link', children: '查看解决方案' }
//         },
//       },
//       {
//         name: 'block1',
//         className: 'block',
//         md: 8,
//         xs: 24,
//         children: {
//           wrapper: { className: 'content5-block-content' },
//           img: {
//             children:
//               'https://zos.alipayobjects.com/rmsportal/faKjZtrmIbwJvVR.svg',
//           },
//           title: { children: '支付宝解决方案' },
//           content: { className: 'content5-block-content-innerText', children: '此处添加相应解决方案' },
//           linkIn: { className: 'content5-block-content-link', children: '查看解决方案' }
//         },
//       },
//       {
//         name: 'block2',
//         className: 'block',
//         md: 8,
//         xs: 24,
//         children: {
//           wrapper: { className: 'content5-block-content' },
//           img: {
//             children:
//               'https://t.alipayobjects.com/images/rmsweb/T11aVgXc4eXXXXXXXX.svg',
//           },
//           title: { children: '蚂蚁金服解决方案' },
//           content: { className: 'content5-block-content-innerText', children: '此处添加相应解决方案' },
//           linkIn: { className: 'content5-block-content-link', children: '查看解决方案' }
//         },
//       }
//     ],
//   },
// };
